<template>
	<div class="mr-12 connections width-100 height-100">
		<router-link class="router" active-class="active" :to="{ name: CONNECTIONS_ROUTE_NAME }">
			<AnemicButton style="background-color: white" class="connection-tab"> App Connections </AnemicButton>
		</router-link>
		<router-link v-if="isTrackingDestinationsEnabled" class="router" active-class="active" :to="{ name: DESTINATIONS_ROUTE_NAME }">
			<AnemicButton style="background-color: white" class="connection-tab">Tracking Destinations</AnemicButton>
		</router-link>
		<router-view v-bind="$props"></router-view>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

import ServiceConnections from './ServiceConnections.vue';
import TrackingConnections from './TrackingConnections.vue';
import { CONNECTIONS_ROUTE_NAME, DESTINATIONS_ROUTE_NAME } from '@/router/router.const';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { isLoadingUserData } from '@/store/modules/auth/getters';
import { getProjectCredentials } from '@/store/modules/credentials/actions';
import { isTrackingDestinationsEnabled } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import AppService from '@/utils/AppService';

export default {
	name: 'Connections',
	props: {
		preselectApp: { type: Object },
		connectionsBySections: { type: Array },
		currentProjectId: { type: [String, Number] },
		canCreateNew: { type: Boolean, default: true },
	},
	computed: {
		...mapGettersShorthand({ hasAccountPermission, isLoadingUserData, isTrackingDestinationsEnabled }),
		isNoResults() {
			return this.connectionsBySections.every((section) => (section.sourceList || []).length === 0);
		},
		isSupported() {
			if (!this.preselectApp) {
				return true;
			}
			return AppService.doesRequiresAuth(this.preselectApp);
		},
		canCreateNewConnection() {
			return this.hasAccountPermission(AccountPermissions.CreateWorkflows);
		},
		isLoading() {
			if (this.isNoResults) {
				return this.isLoadingUserData;
			} else {
				// if we have results, we don't want to show the loading indicator
				return false;
			}
		},
		tabItems() {
			return [
				{
					title: 'App Connections',
					component: ServiceConnections,
					props: this.$props,
				},
				{
					title: 'Tracking Events',
					component: TrackingConnections,
					props: this.$props,
				},
			];
		},
	},
	methods: {
		...mapActions([getProjectCredentials.fullPath]),
		connectProfile() {
			this.connectDialog = true;
		},
	},
	data: () => ({
		selectedTabIndex: 0,
		CONNECTIONS_ROUTE_NAME,
		DESTINATIONS_ROUTE_NAME,
	}),
};
</script>

<style scoped lang="scss">
.connections {
	height: 100%;
	padding-bottom: 150px;
}
.connection-tab {
	background-color: white !important;
	color: #636363;
	border-bottom: 1px solid #e7e6ec;
	height: 70px !important;
	font-size: 14px !important;
	& :hover {
		background-color: white;
		color: #282828;
	}
	& :before {
		background-color: white;
	}
}
.active {
	color: #282828;
	border-bottom: 2px solid #282828 !important;
}
.v-btn:not(.v-btn--rounded):not(.v-btn--tile) {
	border-radius: 0 !important;
}
.description-text {
	font-size: 14px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
	text-align: left;
	letter-spacing: 0px;
}
.v-btn:before {
	background-color: white !important;
}
.router {
	color: unset;
	font-weight: unset;
	text-decoration: unset;
	&.active {
		.connection-tab {
			color: #282828;
			border-bottom: 2px solid #282828 !important;
		}
	}
}
</style>
